import { createError } from '../utils/background/Utils';

interface JwtErrorParams {
    userId?: string | number;
}

const JwtTokenEmptyRoleError = createError({
    name: 'JwtTokenEmptyRoleError',
    message: (p: JwtErrorParams) => `Got token with empty role field. UserId: ${p.userId}`
});

const JwtTokenDecodeError = createError({
    name: 'JwtTokenDecodeError',
    message: `Cound't decode the token`
});

export const JwtTokenErrors = { JwtTokenEmptyRoleError, JwtTokenDecodeError };
